import { Component, Inject, OnInit } from '@angular/core';
import { ColmatageLit } from 'src/app/domain/SANDRE/colmatage-lit';
import { ImportanceVegetationPlacette } from 'src/app/domain/SANDRE/importance-vegetation-placette';
import { NatureVegetationPlacette } from 'src/app/domain/SANDRE/nature-vegetation';
import { SimpleListModel } from 'src/app/models/simple-list-model';
import { ClasseVitesse } from '../../../domain/Shared/classe-vitesse';
import { Materiel } from '../../../domain/Shared/materiel';
import { StringConverter } from '../string-converter';
import { PrelevementDialogModel } from './prelevement-dialog.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { ESousSubstrat } from 'src/app/domain/Shared/enum/sous-substrat';
import { Prelevement } from 'src/app/domain/Shared/prelevement';

@Component({
    selector: 'app-prelevement-dialog',
    templateUrl: './prelevement-dialog.component.html',
    styleUrls: ['./prelevement-dialog.component.scss']
})
export class PrelevementDialogComponent implements OnInit {
    EInterventionType = EInterventionType;
    model: PrelevementDialogModel;
    IntensiteList = [1, 2, 3, 4, 5];
    public MaterielList: string[] =
        Object.values(Materiel)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.getMaterielName(x as Materiel));

    public ColmatageLitList: string[] =
        Object.values(ColmatageLit)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.getColmatageLitName(x as ColmatageLit));

    public NatureVegetationPlacetteList: SimpleListModel[] =
        Object.values(NatureVegetationPlacette)
            .filter(x => !isNaN(Number(x)))
            .map(x => {
                let n = new SimpleListModel();
                n.idx = x as number;
                n.s = StringConverter.getNatureVegetationPlacetteName(x as NatureVegetationPlacette);
                return n;
            });

    public AbondanceList: string[] =
        Object.values(ImportanceVegetationPlacette)
            .filter(x => !isNaN(Number(x)))
            .map(x => StringConverter.getImportanceVegetationPlacetteName(x as ImportanceVegetationPlacette));

    public SousSubstratList: SimpleListModel[] =
        Object.values(ESousSubstrat)
            .filter(x => !isNaN(Number(x)))
            .map(x => {
                let n = new SimpleListModel();
                n.idx = x as number;
                n.s = StringConverter.getSousSubstratName(x as ESousSubstrat);
                return n;
            });

    get CanAdd() {
        return this.model.Prelevement.Materiel && this.model.Prelevement.Profondeur;
    }

    constructor(
        public dialogRef: MatDialogRef<PrelevementDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PrelevementDialogModel) {
        this.model = Object.assign({}, data);
        this.model.Prelevement = Object.assign({}, data.Prelevement);
        if (data.IsCreation) {
            // this.model.Prelevement = new Prelevement();
            this.model.Prelevement.Materiel = Materiel.Surber;
            this.model.Prelevement.Vegetation = NatureVegetationPlacette.Aucune;
        }

        if ((this.model.InterventionType === EInterventionType.MPCE || this.model.InterventionType === EInterventionType.IBGN) && this.model.MainSubstratType) {
            this.filterAvailableSubSubstrat(this.model.InterventionType, this.model.MainSubstratType)
        }

        if (this.model.InterventionType === EInterventionType.MPCE || this.model.InterventionType === EInterventionType.IBGN) { // Retirer les dragues On sait pas pourquoi
            this.MaterielList.splice(2, 2)
        }
    }

    ngOnInit(): void {
    }

    filterAvailableSubSubstrat(int: EInterventionType, mainSubstrat: number) {
        if (int === EInterventionType.MPCE) {
            switch (mainSubstrat) {
                case 3:
                    this.SousSubstratList = this.SousSubstratList.filter(x => x.idx === 11 || x.idx === 8)
                    return;
                case 4:
                    this.SousSubstratList = this.SousSubstratList.filter(x => x.idx === 3 || x.idx === 4)
                    return;
                case 10:
                    this.SousSubstratList = this.SousSubstratList.filter(x => x.idx === 1 || x.idx === 2)
                    return;
                case 12:
                    this.SousSubstratList = this.SousSubstratList.filter(x => x.idx === 5 || x.idx === 7)
                    return;
            }
        }

        if (int === EInterventionType.IBGN) {
            switch (mainSubstrat) {
                case 3:
                    this.SousSubstratList = this.SousSubstratList.filter(x => x.idx === 11 || x.idx === 3 || x.idx === 4)
                    return;
                case 4:
                    this.SousSubstratList = this.SousSubstratList.filter(x => x.idx === 9 || x.idx === 10)
                    return;
                case 8:
                    this.SousSubstratList = this.SousSubstratList.filter(x => x.idx === 1 || x.idx === 2)
                    return;
                case 10:
                    this.SousSubstratList = this.SousSubstratList.filter(x => x.idx === 13 || x.idx === 7)
                    return;
            }
        }
    }

    hasMultipleSubstrat() {
        if (this.model.InterventionType === EInterventionType.MPCE) {
            if (this.model.MainSubstratType === 3 || this.model.MainSubstratType === 4 || this.model.MainSubstratType === 10 || this.model.MainSubstratType === 12)
                return true
        }
        if (this.model.InterventionType === EInterventionType.IBGN) {
            if (this.model.MainSubstratType === 3 || this.model.MainSubstratType === 4 || this.model.MainSubstratType === 8 || this.model.MainSubstratType === 10)
                return true
        }
        return false
    }

    public getClasseVitesseName(c: ClasseVitesse) {
        return StringConverter.getClasseVitesseName(c);
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    onConfirm() {
        this.dialogRef.close(this.model.Prelevement);
    }
}
